<template>
  <template v-for="shift in shifts" :key="shift.id">

    <!-- ### BRANCHES TOWARDS COLUMN -->
    <ShiftWiseBranchesTowardsColumn
        v-if="!branchDirectionTowardRow"
        :session="session"
        :shift="shift"
        :student-counts="studentCounts"
        :branches="branches"
        :class-wise="classWise"
        :branch-wise="branchWise"
        :section-wise="sectionWise"
        :type="type"
    />

    <!-- ### CLASSES TOWARDS COLUMN -->
    <ShiftWiseBranchesTowardsRow v-else
        :session="session"
        :shift="shift"
        :student-counts="studentCounts"
        :branches="branches"
        :classes="classes"
        :class-wise="classWise"
        :branch-wise="branchWise"
        :section-wise="sectionWise"
        :type="type"
    />

  </template>

  <!-- Grand Total -->
  <tr>
    <td :colspan="(!branchDirectionTowardRow && classWise) || (branchDirectionTowardRow && branchWise) ? 2 : 1">
      Grand Total
    </td>
    <td v-if="!branchDirectionTowardRow && branchWise" v-for="branch in branches">
      <SectionWiseCount
          :session="session"
          :student-counts="studentCounts"
          :filter="{branch_id: branch.id}"
          :section="null"
          :is-total="false"
          :section-wise="sectionWise"
          :type="type"
      />
    </td>
    <td v-else-if="branchDirectionTowardRow && classWise" v-for="clazz in classes">
      <SectionWiseCount
          :session="session"
          :student-counts="studentCounts"
          :filter="{class_id: clazz.id}"
          :section="null"
          :is-total="false"
          :section-wise="sectionWise"
          :type="type"
      />
    </td>
    <td v-else>
      <SectionWiseCount
          :session="session"
          :student-counts="studentCounts"
          :filter="{}"
          :section="null"
          :is-total="false"
          :section-wise="sectionWise"
          :type="type"
      />
    </td>
    <td v-if="(!branchDirectionTowardRow && branchWise) || (branchDirectionTowardRow && classWise)">
      <a :href="studentsDetailUrl({})"> {{studentsFilteredBy({}).sum('student_count')}} </a>
    </td>
  </tr>

  <!-- Percentage -->
  <tr v-if="type !== 'total'">
    <td :colspan="(!branchDirectionTowardRow && classWise) || (branchDirectionTowardRow && branchWise) ? 2 : 1">
      Percentage
    </td>
    <td v-if="!branchDirectionTowardRow && branchWise" v-for="branch in branches">
      <SectionWiseCount
          :session="session"
          :student-counts="studentCounts"
          :filter="{branch_id: branch.id}"
          :section="null"
          :is-total="false"
          :is-percentage="true"
          :section-wise="sectionWise"
          :type="type"
      />
    </td>
    <td v-else-if="branchDirectionTowardRow && classWise" v-for="clazz in classes">
      <SectionWiseCount
          :session="session"
          :student-counts="studentCounts"
          :filter="{class_id: clazz.id}"
          :section="null"
          :is-total="false"
          :is-percentage="true"
          :section-wise="sectionWise"
          :type="type"
      />
    </td>
    <td v-else>
      <SectionWiseCount
          :session="session"
          :student-counts="studentCounts"
          :filter="{}"
          :section="null"
          :is-total="false"
          :is-percentage="true"
          :section-wise="sectionWise"
          :type="type"
      />
    </td>
    <td v-if="(!branchDirectionTowardRow && branchWise) || (branchDirectionTowardRow && classWise)"> </td>
  </tr>
</template>

<script>
import { Collection } from "collect.js";
import SectionWiseCount from "./SectionWiseCount.vue";
import ShiftWiseBranchesTowardsColumn from "./ShiftWiseBranchesTowardsColumn.vue";
import ShiftWiseBranchesTowardsRow from "./ShiftWiseBranchesTowardsRow.vue";

export default {
  components: {ShiftWiseBranchesTowardsRow, ShiftWiseBranchesTowardsColumn, SectionWiseCount},
  props: {
    type: String,
    session: Number,
    studentCounts: Collection,
    branches: Collection,
    classes: Collection,
    shifts: Collection,
    classWise: Boolean,
    branchWise: Boolean,
    sectionWise: Boolean,
    branchDirectionTowardRow: Boolean,
  },
  methods: {
    studentsFilteredBy(filter) {
      if (this.session) {
        filter['session_id'] = this.session;
      }

      return this.studentCounts.filter((count) => {
        return Object.keys(filter).every(key => count[key] === filter[key]);
      });
    },
    studentsDetailUrl(filter) {
      if (this.session) {
        filter['session'] = this.session;
      }

      return route('students.index', filter);
    }
  }
}
</script>

<style scoped>
.table th div{
  padding: 0.5rem;
}
</style>